export default [{
    "newsId": 0,
    "sortOrder": 0,
    "picUrl": "https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201222/16086166099c3e5647e3cbb869.jpg",
    "newsTitle": "CEREC 瓷睿刻数字化解决方案",
    "isTop": "0",
    "newsSubTitle": "数字化门诊 - 患者一次就诊解决方案",
    "newsTime": "2022-12-08 17:01:12",
    "newsDetail": "<div style=\"text-align:left;font-size:16px;\">瓷睿刻（CEREC）系统是在苏黎世大学研发的，早在1985年就已被成功应用于牙科临床实践中，至今已有二十多年的历史。全球范围内已有50多个国家30，000多名医生在使用瓷睿刻（CEREC）系统。自1985年已有超过7百万的患者接受过瓷睿刻的治疗，多达一千八百万的全瓷修复体被制作完成并永久粘接。据不完全统计，每十秒钟就有一颗瓷睿刻修复体制作完成，这相当于每天制作8640多颗修复</div><br><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201222/5fe18a0ac653e.jpg\" style=\"width:100%;height:auto;\" alt=\"\" /><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201222/5fe18a1e305ef.jpg\" style=\"width:1220px;height:auto;\" alt=\"\" />",
  },
  {
    "newsId": 1,
    "sortOrder": 0,
    "picUrl": "https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/files/7f5e7d8c9a73b73f647a2f1eedec639.png",
    "newsTitle": "Innovation",
    "isTop": "0",
    "newsSubTitle": "传递最新口腔行业资讯，传播数字化口腔应用技巧，服务于热爱口腔行业的你。",
    "newsTime": "2022-11-08 18:18:09",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201222/5fe190f3a04e6.png\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201222/5fe190f48c8ad.png\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20201222/5fe190f56cb75.png\" alt=\"\"></div>"
  },
  {
    "newsId": 2,
    "sortOrder": 0,
    "picUrl": "https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/16191426971028ef5facda5855.jpg",
    "newsTitle": "德国迪瑞氧化锆",
    "isTop": "0",
    "newsSubTitle": "德国品牌，触手可得",
    "newsTime": "2022-11-05 15:25:12",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/6082283a59563.jpg\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822844a6f86.jpg\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822851a3aa2.jpg\"></div>"
  },
  {
    "newsId": 3,
    "sortOrder": 0,
    "picUrl": "static/images/left_banner_1.jpg",
    "newsTitle": "日照日报头版头条",
    "isTop": "1",
    "newsSubTitle": "日照两家企业上榜国家级典型案例",
    "newsTime": "2022-11-05 15:25:12",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/6082283a59563.jpg\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822844a6f86.jpg\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822851a3aa2.jpg\"></div>"
  },
  {
    "newsId": 4,
    "sortOrder": 0,
    "picUrl": "static/images/left_banner_2.jpg",
    "newsTitle": "入选省2025“工赋百景”揭榜挂帅项目",
    "isTop": "1",
    "newsSubTitle": "驱动口腔产业链数字化蝶变",
    "newsTime": "2022-11-05 15:25:12",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/6082283a59563.jpg\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822844a6f86.jpg\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822851a3aa2.jpg\"></div>"
  },
  {
    "newsId": 5,
    "sortOrder": 0,
    "picUrl": "static/images/left_banner_3.jpg",
    "newsTitle": "德国迪瑞氧化锆",
    "isTop": "1",
    "newsSubTitle": "德国品牌，触手可得",
    "newsTime": "2022-11-05 15:25:12",
    "newsDetail":"<div class=\"pad-50  f-16 content\" style=\"min-height: 400px;\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/6082283a59563.jpg\" alt=\"\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822844a6f86.jpg\"><img src=\"https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822851a3aa2.jpg\"></div>"
  },
  // {
  //   "newsId": 3,
  //   "sortOrder": 0,
  //   "picUrl": "https://maier.oss-cn-beijing.aliyuncs.com/Public/Upload/image/20210423/60822844a6f86.jpg",
  //   "newsTitle": "诺保科",
  //   "newsSubTitle": "漂亮得不像实力派漂亮得不像实力派漂亮得不像实力派漂亮得不像实力派漂亮得不像实力派",
  //   "newsTime": "2022-11-01 09:10:00",
  //   "newsDetail":"<div><div style=\"background:#f5f5f5; padding:50px; position:relative\"><p>在口腔种植领域，Nobel Biocare™诺保科®的历史独特而珍贵：由\"现代种植学之父\"，瑞典科学家布伦马克教授（Per-Ingvar Brånemark）创立，经口腔专业人士们孜孜不倦的研究与实践，至今仍为改善缺牙患者的生活质量而创新不止。</p><p>&nbsp;</p><p>品牌创始人：\"现代种植牙之父\"-布伦马克教授<br>1952年，布伦马克教授（Per-Ingvar Brånemark）发现了钛金属与动物骨骼的骨结合现象，经17年不懈研究创立骨结合理论，从此奠定现代口腔种植学基础。他曾两次获诺贝尔奖提名，荣获欧洲发明人终生成就奖。</p><p>&nbsp;</p><div style=\"width:100%;height:36px;background-color: #cb0101;color:#ffffff\"><span style=\"font-size:20px;\"><strong>&nbsp;Nobel Biocare™里程碑</strong></span></div><p><img src=\"https://www.envistaco.com.cn/sites/default/files/img.jpg\" style=\"width: 1070px; height: 764px;\"></p></div></div>"


  // }
]



// WEBPACK FOOTER //
// ./src/assets/config/newsList.js